<template>
  <div class="card mb-3">
    <div class="card-body">
      <div class="media align-items-center">
        <div class="media-right text-nowrap mr-4">
          <div class="h3 mb-1">
            <span :class="[
              'badge',
              {
                'badge-light-gray': !member.available,
                'badge-success': member.available
              }
            ]">
              <i
                v-if="member.available"
                class="fa fa-fw fa-check-circle-o"
              ></i>
              <i
                v-if="!member.available"
                class="fa fa-fw fa-circle-o"
              ></i>
            </span>
          </div>
        </div>
        <div class="media-body">
          <div class="font-weight-bold">
            {{ member.name }}
            <i
              v-if="member.leader"
              class="fa fa-star ml-2 text-gold"
              title="Team Leader"
            ></i>
          </div>
          <div>{{ member.formatted_phone }}</div>
          <div class="small">
            <a :href="`mailto:${member.email}}`">
              {{ member.email }}
            </a>
          </div>
        </div>
        <div class="media-left">
          <toggle-button
            v-if="member.can.update"
            v-model="member.available"
          ></toggle-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import { toggleCallCenterMemberAvailable } from '@/api'

export default {
  components: {
    ToggleButton
  },
  props: {
    callCenter: {
      type: Object,
      required: true
    },
    member: {
      type: Object,
      required: true
    }
  },
  watch: {
    async 'member.available' () {
      const response = await toggleCallCenterMemberAvailable(
        this.callCenter.id,
        this.member.id
      )
    }
  },
  mounted () {
    //
  }
}
</script>